import Firebase from 'firebase/app'
import 'firebase/firestore'

export class AdminGameConnection {
  constructor(gameId) {
    this.connection = new window.WebSocket(
      `${process.env.REACT_APP_WEBSOCKET_URL}/admin_socket/${gameId}`
    )
  }

  onSnapshot(fn) {
    this.connection.onmessage = data => fn(JSON.parse(data))
  }
  set(data) {
    let json = JSON.stringify({
      action: 'update_game',
      data
    })
    this.connection.send(json)
    return Promise.resolve()
  }
  result(data) {
    let json = JSON.stringify({
      action: 'outcome',
      data: {
        result: data
      }
    })
    this.connection.send(json)
    return Promise.resolve()
  }
  nextPlay() {
    let json = JSON.stringify({
      action: 'change_tag'
    })
    this.connection.send(json)
    return Promise.resolve()
  }
}

class Crud {
  constructor(collection) {
    this.collection = collection
  }

  create(fields) {
    return this.collection.add(fields)
  }
  update(id, fields) {
    return this.collection.doc(id).update(fields)
  }
  delete(id) {
    return this.collection.doc(id).delete()
  }
  ref(id) {
    return this.collection.doc(id)
  }
  findById(id) {
    return this.collection
      .doc(id)
      .get()
      .then(doc => ({ id: doc.id, ...doc.data() }))
  }
  find(query, format) {
    const entries = Object.entries(query)
    return (entries.length > 0
      ? entries.reduce(
          (accumulator, [field, value]) =>
            accumulator.where(field, '==', value),
          this.collection
        )
      : this.collection
    )
      .get()
      .then(snap =>
        Promise.all(snap.docs.map(doc => format({ id: doc.id, ...doc.data() })))
      )
  }
}

class Connection {
  static initialize() {
    Firebase.initializeApp({
      apiKey: 'AIzaSyBSSBxTY_NdzhM7QV7ygBCxskKWflM_sUk',
      projectId: 'couchcoach-9fa52'
    })
    Firebase.firestore().settings({ timestampsInSnapshots: true })
  }

  get env() {
    return Firebase.firestore()
      .collection('env')
      .doc(process.env.NODE_ENV)
  }
  get games() {
    const collection = this.env.collection('games')
    return new Crud(collection)
  }
  get users() {
    const collection = this.env.collection('users')
    return new Crud(collection)
  }
  get lobbies() {
    const collection = this.env.collection('lobbies')
    return new Crud(collection)
  }
  get teams() {
    const collection = this.env.collection('teams')
    return new Crud(collection)
  }
}

export default (() => {
  let connection = new Connection()
  return Object.assign(connection, {
    initialize() {
      Connection.initialize()
    }
  })
})()



// WEBPACK FOOTER //
// ./src/helpers/db.js